import React from "react";
import { Field } from "redux-form";
//Field трансформируется в Input(type=radio)

/**
 @param Name = Наименование для бекенда
 @param value = Значение переменной, которое будет записано, если нажать на кнопку(записано в бек)
 @param id = Айди для определения лейбла и Radio button, чтобы при нажатии на label кнопка radio тоже нажималась
 @param func = функция, передаваемая в кнопку(это нужно для фронта по моей части)
 @param txt = Наименование, типо (стекло, зеркало и т.д.)
 */
const BasketRadio = ({name, value, id, func = () => void 0, txt = ""}) => (
    <div className="calc_checker_box">
        <Field className="calc_checker" component={"input"} value={value}
               onClick={func} name={name}
               id={id} type={"radio"}/>
        <label className="calc_checker_text" style={{textAlign: "left", margin: "5px 0"}} htmlFor={id}>{txt}</label>
    </div>
)

export default BasketRadio;